import * as QRCode from 'qrcode'
import { get } from 'lodash'
import * as JsBarCode from 'jsbarcode'

import { frontendURL, findCountry, getArray } from '../../utils'

// @ts-ignore
const countries = require('./../../assets/countries.json')

export const fonts = [
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Raleway',
  'Merriweather',
  'Ubuntu',
  'Poppins',
  'Lora',
  'Oxygen',
  'Cabin',
  'MuseoSans',
  'GothamRounded',
]
export const fontSizes = [8, 9, 10, 11, 12, 14, 16, 18, 21, 24, 28, 32, 36, 40, 48, 54, 60, 72]

// 96 DPI default
export const pixelToMM = pixel => pixel * 0.264583333
export const mmToPixel = mm => mm * 3.779527559
export const changeOrientation = orientation => {
  if (orientation === 'PORTRAIT') return 'LANDSCAPE'

  return 'PORTRAIT'
}

export const formats = [
  {
    name: 'A6',
    label: 'A6 (105mm x 148mm)',
    width: 105,
    height: 148.4,
    defaultOrientation: 'PORTRAIT',
    defaultPrintOrientation: 'PORTRAIT',
  },
  {
    name: 'A6X2',
    label: 'A6 (2x) (210mm x 148mm)',
    width: 105 * 2,
    height: 148.4,
    defaultOrientation: 'PORTRAIT',
    defaultPrintOrientation: 'PORTRAIT',
  },
  {
    name: 'H1',
    label: 'Hawaki (100mm x 148mm)',
    width: 100,
    height: 148.4,
    defaultOrientation: 'PORTRAIT',
    defaultPrintOrientation: 'PORTRAIT',
  },
  {
    name: 'T1',
    label: 'Tickets (130mm x 74.25mm)',
    width: 130,
    height: 74.2,
    defaultOrientation: 'LANDSCAPE',
    defaultPrintOrientation: 'PORTRAIT',
  },
  {
    name: 'BC1',
    label: 'Business card (86mm x 54mm)',
    width: 86,
    height: 54,
    defaultOrientation: 'LANDSCAPE',
    defaultPrintOrientation: 'PORTRAIT',
  },
]

export const defaultStyles = {
  textItem: {
    size: 24,
    color: '#000000',
    font: 'Roboto',
    textAlign: 'left',
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    height: 40,
    width: 200,
  },
  customTextItem: {
    size: 24,
    color: '#000000',
    font: 'Roboto',
    textAlign: 'left',
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    height: 150,
    width: 200,
  },
  shapeItem: {
    backgroundColor: '#979797',
  },
  avatarItem: {
    backgroundImage: `${frontendURL}/assets/avatar.svg`,
    height: 150,
    width: 120,
  },
  flagItem: {
    backgroundImage: `${frontendURL}/assets/flag.svg`,
    height: 100,
    width: 148,
  },
  qrCodeItem: {
    backgroundImage: `${frontendURL}/assets/qr-code.svg`,
    height: 100,
    width: 100,
  },
  barcodeItem: {
    backgroundImage: `${frontendURL}/assets/barcode.svg`,
    height: 63,
    width: 148,
  },
  zoneItem: {
    size: 24,
    color: '#000000',
    font: 'Roboto',
    textAlign: 'center',
    bold: false,
    italic: false,
    underline: false,
    uppercase: false,
    height: 50,
    width: 50,
  },
}

async function generateQrCode(accreditation) {
  return QRCode.toDataURL(accreditation.qrcode.toString())
}
async function generateBarcode(accreditation) {
  const canvas = document.createElement('canvas')
  JsBarCode(canvas, accreditation.barcode, { format: 'CODE39' })

  return canvas.toDataURL('image/png')
}
function renderMultiSelect(items) {
  const itemsAsHtml = getArray(items).map(renderMultiSelectItem).join('')

  return `<ul>${itemsAsHtml}</ul>
  `
}

function renderMultiSelectItem(item) {
  return `
      <li>
        ${item}
      </li>
    `
}

export const itemToAccreditationField = async (item, accreditation, attendeeFields) => {
  const {
    styles: { rotate, borderRadius, ...childStyles },
    x,
    y,
    w,
    h,
    z,
    ...rest
  } = item
  const { type, subtype, databaseField, data, placeholder, id, meta } = rest
  const parentStyles = { x, y, w, h, z, rotate }
  if (type === 'custom' && subtype === 'flag') {
    const countryField = attendeeFields.find(field => field.type === 'country')
    const countryValue = accreditation.fields[countryField.name]
    const country = countryValue && findCountry(countries, countryValue.toLowerCase())

    const backgroundImage = country
      ? `${frontendURL}/assets/flags/${country.iso2.toLowerCase()}.svg`
      : `${frontendURL}/assets/flag.svg`

    return { childStyles, flag: true, parentStyles: { backgroundImage, ...parentStyles } }
  } else if (type === 'custom' && subtype === 'computed') {
    const data = item.fields.map(field => accreditation.fields[field]).join(' ')

    return { data, text: true, childStyles, parentStyles, id }
  } else if (subtype === 'country-code') {
    const countryField = attendeeFields.find(field => field.type === 'country')

    return {
      data: accreditation.fields[countryField.name],
      text: true,
      childStyles,
      parentStyles,
      id,
    }
  } else if (subtype === 'country-name') {
    const countryField = attendeeFields.find(field => field.type === 'country')
    const countryValue = accreditation.fields[countryField.name]
    const country = countryValue && findCountry(countries, countryValue.toLowerCase())
    const countryCommon = country ? country.common : ''

    return { data: countryCommon, text: true, childStyles, parentStyles, id }
  } else if (subtype === 'custom-avatar') {
    const avatarField = attendeeFields.find(field => field.type === 'avatar-field')
    const backgroundImage =
      accreditation.fields[avatarField.name] ||
      accreditation.avatar ||
      `${frontendURL}/assets/avatar-r0.svg`

    return { childStyles, avatar: true, parentStyles: { backgroundImage, ...parentStyles } }
  } else if (type === 'category') {
    const {
      category: { name },
    } = accreditation

    return { data: name, text: true, childStyles, parentStyles, id }
  } else if (type === 'custom') {
    if (meta && meta.component === 'select-field-multiple') {
      const data = renderMultiSelect(accreditation.fields[placeholder] || [' '])

      return { data, text: true, childStyles, parentStyles, id, asHtml: true }
    }

    return {
      data: accreditation.fields[placeholder] || '',
      text: true,
      childStyles,
      parentStyles,
      id,
      asHtml: false,
    }
  } else if (type === 'field' && databaseField && placeholder) {
    return { data: accreditation[databaseField], text: true, childStyles, parentStyles, id }
  } else if (subtype === 'avatar') {
    const backgroundImage = accreditation[databaseField]
      ? accreditation[databaseField]
      : `${frontendURL}/assets/avatar-r0.svg`

    return { childStyles, avatar: true, parentStyles: { backgroundImage, ...parentStyles } }
  } else if (type === 'custom-image') {
    const { data: backgroundImage } = item

    return {
      childStyles: {
        position: 'absolute',
        top: '0',
        clip: `rect(0px, ${w}px, ${h}px, 0px)`,
        ...childStyles,
      },
      image: true,
      parentStyles: { backgroundImage, ...parentStyles },
    }
  } else if (type === 'shape') {
    const { backgroundColor: color, isCategory } = childStyles
    const backgroundColor = isCategory ? accreditation.category.color : color

    return {
      childStyles,
      oval: subtype === 'oval',
      parentStyles: { backgroundColor, borderRadius, ...parentStyles },
    }
  } else if (type === 'custom-text') {
    return { data, childStyles, parentStyles, id }
  } else if (type === 'qr-code') {
    const qrCode = await generateQrCode(accreditation)

    return { qrCode: true, childStyles, parentStyles: { backgroundImage: qrCode, ...parentStyles } }
  } else if (subtype === 'barcode') {
    const barcode = accreditation && accreditation.barcode && (await generateBarcode(accreditation))

    return {
      barcode: true,
      childStyles,
      parentStyles: { backgroundImage: barcode, ...parentStyles },
    }
  } else if (
    type === 'zone' &&
    accreditation.zones &&
    accreditation.zones.includes(placeholder) &&
    childStyles.backgroundImage
  ) {
    const { backgroundImage } = childStyles

    return {
      data: placeholder,
      image: true,
      childStyles,
      parentStyles: { backgroundImage, ...parentStyles },
    }
  } else if (type === 'zone' && accreditation.zones && accreditation.zones.includes(placeholder)) {
    return { data: placeholder, childStyles, parentStyles }
  } else if (type === 'printCount') {
    return { data: accreditation.printCount, childStyles, parentStyles }
  }

  return { data, childStyles, parentStyles }
}

export const previewData = {
  id: '1',
  fields: {},

  barcode: '20238323',
  qrcode: '20238323',
  zones: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  category: {
    id: 9,
    name: 'VIP',
    color: '#ABCDEF',
    zones: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  printCount: 3,
}

export const dropData = {
  custom: {
    type: 'custom',
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
  fullName: {
    type: 'custom',
    subtype: 'computed',
    placeholder: 'Full name',
    fields: ['First name', 'Last name'],
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
  countryCode: {
    type: 'custom',
    subtype: 'country-code',
    placeholder: 'Country code',
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
  customAvatar: {
    type: 'custom',
    toolbar: 'avatar',
    subtype: 'custom-avatar',
    styles: defaultStyles.avatarItem,
  },
  flag: {
    type: 'custom',
    subtype: 'flag',
    styles: defaultStyles.flagItem,
  },
  countryName: {
    type: 'custom',
    subtype: 'country-name',
    placeholder: 'Country name',
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
  category: {
    type: 'category',
    placeholder: 'Category',
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
  avatar: {
    type: 'field',
    subtype: 'avatar',
    databaseField: 'avatar',
    styles: defaultStyles.avatarItem,
  },
  qrCode: {
    type: 'qr-code',
    styles: defaultStyles.qrCodeItem,
  },
  customText: {
    type: 'custom-text',
    toolbar: 'text',
    styles: defaultStyles.customTextItem,
  },
  customImage: {
    type: 'custom-image',
    styles: {},
  },
  oval: {
    type: 'shape',
    subtype: 'oval',
    toolbar: 'color',
    styles: defaultStyles.shapeItem,
  },
  rectangle: {
    type: 'shape',
    subtype: 'rectangle',
    toolbar: 'color',
    styles: defaultStyles.shapeItem,
  },
  square: {
    type: 'shape',
    subtype: 'rectangle',
    toolbar: 'color',
    styles: { ...defaultStyles.shapeItem, width: 100, height: 100 },
  },
  roundedRectangle: {
    type: 'shape',
    subtype: 'rectangle',
    toolbar: 'color',
    styles: { ...defaultStyles.shapeItem, borderRadius: 12 },
  },
  barcode: {
    type: 'field',
    subtype: 'barcode',
    databaseField: 'barcode',
    styles: defaultStyles.barcodeItem,
  },
  zone: {
    type: 'zone',
    toolbar: 'text',
    styles: defaultStyles.zoneItem,
  },
  printCount: {
    type: 'printCount',
    toolbar: 'text',
    placeholder: 'PRINT_COUNT',
    styles: defaultStyles.textItem,
  },
  id: {
    type: 'field',
    databaseField: 'id',
    placeholder: 'ID',
    toolbar: 'text',
    styles: defaultStyles.textItem,
  },
}
